import { httpsCallable } from "firebase/functions";
import { observer } from "mobx-react";
import { cFunctions } from "../../../firebase";
import { useEffect, useState } from "react";
import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { LogRow } from "../../../Model/log";
import { portalStore } from "../../../Stores/portal";
import { useParams } from "react-router";
import axios from "axios";

const _TournamentLog: React.FC = () => {
  const [data, setData] = useState<LogRow[] | null>(null);
  const { id } = useParams();
  const [liveData, setLiveDate] = useState<LogRow>();
  const loadResults = () => {
    const obj = { id: id } as { id: string };
    axios
      .get(`https://getlogv2-ktninsi3ma-uc.a.run.app?id=${obj.id}`)
      .then((r) => {
        console.log(r);
        const val = r.data as unknown as any;
        if (val) {
          setData(val["value"] as LogRow[]);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    if (id) {
      loadResults();
    }
  }, [id]);

  if (data === null) {
    return <CircularProgress disableShrink />;
  }

  if (data.length === 0) {
    return <h1>No Data</h1>;
  }

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        textAlign: "left",
        padding: "10px",
        height: portalStore.portalHeight,
      }}
    >
      <label>Table</label>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell align="left">Player</TableCell>
              <TableCell align="left">Games</TableCell>
              <TableCell align="left">Win</TableCell>
              <TableCell align="left">Draw</TableCell>
              <TableCell align="left">Lose</TableCell>
              <TableCell align="left">Points</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, i) => (
              <TableRow
                key={row.playerID}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {"" + (i + 1)}
                </TableCell>
                <TableCell align="left">{row.playerNickname}</TableCell>
                <TableCell align="left">{row.games}</TableCell>
                <TableCell align="left">{row.wins}</TableCell>
                <TableCell align="left">{row.draws}</TableCell>
                <TableCell align="left">{row.loss}</TableCell>
                <TableCell align="left">{row.points}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const TournamentLog = observer(_TournamentLog);

export { TournamentLog };
